import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MenuDTO } from '../models/menu-dto';
import { environment } from 'src/environments/environment';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private pathAPI = environment.urlAPI;
  private controller = "Shared/";
  menus: any[] = [];

  constructor(private http: HttpClient) { }

  public getMenu(): Observable<MenuDTO> {
    return this.http.get<MenuDTO>(this.pathAPI + this.controller + 'GetMenu');
  }

  public GetMenuPath(data): any[] {

    this.menus = [];

    data.forEach(elem => {

      if (elem.SubItems != null && elem.SubItems.length > 0) {

        elem.SubItems.forEach(elem2 => {

          if (elem2.SubItems != null && elem2.SubItems.length > 0) {

            elem2.SubItems.forEach(elem3 => {

              if (elem3.SubItems != null && elem3.SubItems.length > 0) {

                elem3.SubItems.forEach(elem4 => {

                  if (elem4.Url != '' && elem4.Url != null && !elem4.Url.startsWith('/adm')) {

                    this.menus.push({
                      value: elem4.Url,
                      label: elem4.Title,
                      data: elem4.Id
                    });

                  }

                });

              }
              else {

                if (elem3.Url != '' && elem3.Url != null && !elem3.Url.startsWith('/adm')) {

                  this.menus.push({
                    value: elem3.Url,
                    label: elem3.Title,
                    data: elem3.Id
                  });

                }

              }

            })

          }

          else {

            if (elem2.Url != '' && elem2.Url != null && !elem2.Url.startsWith('/adm')) {

              this.menus.push({
                value: elem2.Url,
                label: elem2.Title,
                data: elem2.Id
              });

            }

          }

        });

      }
      else {

        if (elem.Url != '' && elem.Url != null && !elem.Url.startsWith('/adm')) {

          this.menus.push({
            value: elem.Url,
            label: elem.Title,
            data: elem.Id
          });

        }

      }

    });
    return this.menus;
  }

  public getStihlFilters(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlFilters');
  }

  public getStihlForumType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlForumType');
  }

  public getStihlDistributors(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDistributors');
  }

  public getStihlRoles(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlRoles');
  }

  public getStihlDistricts(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDistricts');
  }

  public getStihlDistributorType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihlDistributorType');
  }


  public getStihlUserByRoles(roles: number[]): Observable<Select2Data> {
    return this.http.post<Select2Data>(this.pathAPI + this.controller + 'GetStihlUserByRoles', roles);
  }


  public getMailingList(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetMailingList/');
  }

  public getCampaignMaterialMediaType(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetCampaignMaterialMediaType/');
  }

  public GetRrss(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetRrss/');
  }

  public getStihlCustomStatus(idStatus: number[]): Observable<Select2Data> {
    return this.http.post<Select2Data>(this.pathAPI + this.controller + 'GetStihlCustomStatus', idStatus);
  }

  public getStihAllMonth(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStihAllMonth');
  }

  public GetMyDistributorsList(): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.pathAPI + this.controller + 'GetMyDistributorsList');
  }

  public GetMyDistributorsSeguimientoList(id): Observable<Array<any>> {
    return this.http.get<Array<any>>(this.pathAPI + this.controller + 'GetMyDistributorsSeguimientoList/' + id);
  }

}
